const handler = ( $ ) => {
	const settingsReviews = {
		infinite: true,
		autoplay: true,
		autoplaySpeed: 6000,
		speed: 500,
		pauseOnHover: true,
		mobileFirst: true,
		slidesToShow: 1,
		slidesToScroll: 1,
		dots: false,
		arrows: false,
	};

	const $slider = $( '.reviews-section .reviews' );
	$slider.on( 'init', function ( event, slick ) {
		updateUI( 0, slick, $( this ) );
	} );

	$slider.on(
		'beforeChange',
		function ( event, slick, currentSlide, nextSlide ) {
			updateUI( nextSlide, slick, $( this ) );
		}
	);

	function updateUI( nextSlide, slick, $this ) {
		const currentSlide = nextSlide + 1;
		const calc = ( currentSlide / slick.slideCount ) * 100;
		const $progressBar = $this
			.closest( '.reviews-section' )
			.find( '.progress-bar' );
		$progressBar.css( 'width', calc + '%' );
		const i = currentSlide ? currentSlide : 0;

		const $status = $this
			.closest( '.reviews-section' )
			.find( '.paging-info' );
		$status.text( '0' + i + ' / 0' + slick.slideCount );
	}

	$slider.slick( settingsReviews );
	$( window ).on( 'resize', function () {
		if (
			$( window ).width() < 870 &&
			! $slider.hasClass( 'slick-initialized' )
		) {
			$slider.slick( settingsReviews );
		}
	} );

	$( '.slider-meta .icon-prev' ).on( 'click', function () {
		$( '.reviews' ).slick( 'slickPrev' );
	} );

	$( '.slider-meta .icon-next' ).on( 'click', function () {
		$( '.reviews' ).slick( 'slickNext' );
	} );

	const slideCount = $slider.find( '.slick-slide:not(.slick-cloned)' ).length;
	if ( slideCount > 1 ) {
		$slider
			.closest( '.reviews-section' )
			.find( '.slider-meta' )
			.addClass( 'd-flex' )
			.removeClass( 'd-none' );
	}
};

export default ( ( $ ) => $( handler ) )( jQuery );
